import { render, staticRenderFns } from "./channelswitchhistory.vue?vue&type=template&id=0666718a&scoped=true"
import script from "./channelswitchhistory.vue?vue&type=script&lang=js"
export * from "./channelswitchhistory.vue?vue&type=script&lang=js"
import style0 from "./channelswitchhistory.vue?vue&type=style&index=0&id=0666718a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0666718a",
  null
  
)

export default component.exports